// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e20bcede","247":"a847a021","284":"506915ec","457":"127b1fe7","627":"a8b17973","664":"50f2410d","683":"457c552d","867":"4f841f2a","923":"c9b885b8"}[chunkId] + ".chunk.js";
};